import React from 'react';
import { Button, useColorModeValue, Flex, Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const GradientButton = ({
  icon,
  leftIcon,
  children,
  fontSize = 'xs',
  width = 'auto',
  height = '40px',
  loading = false,
  isDisabled = false,
  ...props
}) => {
  const bgButton = useColorModeValue(
    "linear-gradient(134.23deg, #071D54 14.41%, #1E3A8A 85.58%)",
    "gray.800"
  );

  const bounceTransition = {
    y: {
      duration: 0.6,
      yoyo: Infinity,
      ease: "easeOut"
    },
    opacity: {
      duration: 0.6,
      yoyo: Infinity,
      ease: "easeOut"
    }
  };

  const renderLoadingDots = () => (
    <Flex alignItems="center" justifyContent="center">
      {[0, 1, 2].map((i) => (
        <MotionBox
          key={i}
          w="6px"
          h="6px"
          bg="white"
          borderRadius="50%"
          mx="2px"
          animate={{
            y: ["0%", "-50%", "0%"],
            opacity: [0.3, 1, 0.3],
          }}
          transition={{
            delay: i * 0.2,
            ...bounceTransition,
          }}
        />
      ))}
    </Flex>
  );

  return (
    <Button
      bg={bgButton}
      color="white"
      fontSize={fontSize}
      variant="no-hover"
      borderRadius="8px"
      width={width}
      height={height}
      isDisabled={isDisabled || loading}
      leftIcon={!loading && leftIcon}
      _loading={{
        bg: bgButton,
      }}
      {...props}
    >
      <Flex alignItems="center" justifyContent="center" w="100%">
        {loading ? renderLoadingDots() : (
          <>
            {icon && <Box mr="4px">{icon}</Box>}
            {children}
          </>
        )}
      </Flex>
    </Button>
  );
};

export default GradientButton;
